// (c) chaehongee. Confidential and proprietary.

import { useCallback, useMemo, useState } from 'react'

export interface StackNavigator<T> {
    current: T
    stack: T[]
    canGoBack: boolean
    push: (value: T) => void
    replace: (value: T) => void
    pop: () => void
    reset: (value: T) => void
    goBack: () => void
}

export function useStackNavigator<T>(initial: T): StackNavigator<T> {
    const [stack, setStack] = useState<T[]>([initial])
    const current = stack[stack.length - 1] as T
    const canGoBack = stack.length > 1

    const push = useCallback((value: T) => {
        setStack((s) => [...s, value])
    }, [])

    const replace = useCallback((value: T) => {
        setStack((s) => {
            if (s.length === 0) return [value]
            const next = s.slice(0, -1)
            next.push(value)
            return next
        })
    }, [])

    const pop = useCallback(() => {
        setStack((s) => (s.length > 1 ? s.slice(0, -1) : s))
    }, [])

    const reset = useCallback((value: T) => {
        setStack([value])
    }, [])

    const goBack = useCallback(() => {
        setStack((s) => (s.length > 1 ? s.slice(0, -1) : s))
    }, [])

    return useMemo(() => ({ current, stack, canGoBack, push, replace, pop, reset, goBack }), [current, stack, canGoBack, push, replace, pop, reset, goBack])
}



